module.exports = __webpack_public_path__ + "img/FP_landingspage_tarief.9e164340.png";